<template>
    <div class="bameiNewHome">
      <Header
        :tabList="tabList"
        :isEnglish="isEnglish" 
        :Selectlanguage="Selectlanguage"
        :value="selectValue"
        @change="onTabChange"
        @lang="onLanChane"
      />
      <router-view></router-view>
      <Footer></Footer>
    </div>
</template>
<script>
import { mapState } from 'vuex';
import Header from './components/header';
import Footer from './components/footer';
export default {
    components: {
    Header,
    Footer
  },
  provide() {
    return {
      reload: this.reload
    };
  },
  data() {
    return {
      tabList: [
        {
          label: '首页',
          value: 'home',
          routeName: 'bameiNewHomePage',
          path: '/index'
        },
        {
          label: '秘境桃源',
          value: 'secretGarden',
          routeName: 'bameiNewSecretGarden',
          children: [
            {
              label: '景区简介',
              value: 'bameiIntroduce',
              routeName: 'bameiNewIntroduce',
              path: '/introduce',
              query: {
                pid: 2842,
                menuId: 932,
                m_id: this.$route.query.m_id || 1758
              }
            },
            {
              label: '桃源风光',
              value: 'scenery',
              routeName: 'bameiNewScenery',
              path: '/introduce',
              query: {
                pid: 2843,
                menuId: 933,
                m_id: this.$route.query.m_id || 1758
              }
            },
            {
              label: '人文风情',
              value: 'cultural',
              routeName: 'bameiNewCultural',
              path: '/introduce',
              query: {
                pid: 2844,
                menuId: 934,
                m_id: this.$route.query.m_id || 1758
              }
            },
          ]
        },
        {
          label: '在线预定',
          value: 'onlineBook',
          routeName: 'bameiNewOnlineBook',
          children: [
            {
              label: '门票预定',
              value: 'bameiContactUs',
              routeName: 'bameiNewTicketOrder',
              path: '/list/ticket',
              query: {
                page: 1,
                m_id: this.$route.query.m_id || 1758
              }
            },
            {
              label: '优惠政策',
              value: 'bameiDiscount',
              routeName: 'bameiNewDiscount',
              path: '/introduce',
              query: {
                pid: 2845,
                menuId: 1015,
                m_id: this.$route.query.m_id || 1758
              }
            },
          ]
        },
        {
          label: '桃源热点',
          value: 'news',
          routeName: 'bameiNewNewslist',
          children: [
            {
              label: '资讯分享',
              value: 'bameiNewsSharing',
              routeName: 'bameiNewNewsSharing',
              // path: '/introduce',
              path: '/newslist',
              query: {
                // pid: 2841,
                // menuId: 1013,
                pid: 1013,
                m_id: this.$route.query.m_id || 1758
              }
            }
          ]
        },
        {
          label: '游园攻略',
          value: 'strage',
          routeName: 'bameiNewStrategy',
          children: [
            {
              label: '游园攻略',
              value: 'bameiPlayStrategy',
              routeName: 'bameiNewPlayStrategy',
              path: '/introduce',
              query: {
                pid: 1495,
                menuId: 615,
                m_id: this.$route.query.m_id || 1758
              }
            },
            {
              label: '游客须知',
              value: 'bameiContactUs',
              routeName: 'bameiNewTouristNotice',
              path: '/introduce',
              query: {
                pid: 2846,
                menuId: 1016,
                m_id: this.$route.query.m_id || 1758
              }
            },
          ]
        },
        {
          label: '企业简介',
          value: 'companyIntroduce',
          routeName: 'bameiCompanyIntroduce',
          path: '/introduce',
          query: {
            pid: 2849,
            menuId: 1017,
            m_id: this.$route.query.m_id || 1758
          }
        },
        {
          label: '服务中心',
          value: 'serviceCenter',
          routeName: 'bameiNewServiceCenter',
          children: [
            {
              label: '联系我们',
              value: 'bameiContactUs',
              routeName: 'bameiNewContactUs',
              // path: '/detail/news',
              path: '/introduce',
              query: {
                pid: 2847,
                menuId: 938,
                m_id: this.$route.query.m_id || 1758
              }
            },
            {
              label: '常见问题',
              value: 'bameiCommonQuestion',
              routeName: 'bameiNewCommonQuestion',
              // path: '/detail/news',
              path: '/introduce',
              query: {
                pid: 2848,
                menuId: 1013,
                m_id: this.$route.query.m_id || 1758
              }
            },
          ]
        },
      ],
      selectValue: 'bameiNewHomePage',
      ticketList: [],
      shopList: [],
      isEnglish: false,
      Selectlanguage: 'chinese'
    };
  },
  computed: {
    ...mapState("privateConfig", ["pageWidth"])
  },
  watch: {
    $route(val) {
      this.selectValue = localStorage.getItem('selectValue');
    }
  },
  methods: {
    reload() {
      this.isRouterAlive = false;
      //在修改数据之后使用 $nextTick，则可以在回调中获取更新后的 DOM
      this.$nextTick(() => {
        this.isRouterAlive = true;
      });
    },
    onTabChange(data) {
      this.selectValue = data.routeName;
      
      if (['bameiNewIntroduce', 'bameiNewScenery', 'bameiNewCultural'].includes(data.routeName)) {
        localStorage.setItem('selectValue', 'bameiNewSecretGarden'); // 秘境桃源
      } else if (['bameiNewTicketOrder', 'bameiNewDiscount'].includes(data.routeName)) {
        localStorage.setItem('selectValue', 'bameiNewOnlineBook'); // 在线预订
      } else if (['bameiNewNewsSharing'].includes(data.routeName)) {
        localStorage.setItem('selectValue', 'bameiNewNewslist'); // 桃源热点
      } else if (['bameiNewPlayStrategy', 'bameiNewTouristNotice'].includes(data.routeName)) {
        localStorage.setItem('selectValue', 'bameiNewStrategy'); // 游园攻略
      } else if (['bameiNewContactUs', 'bameiNewCommonQuestion'].includes(data.routeName)) {
        localStorage.setItem('selectValue', 'bameiNewServiceCenter'); // 服务中心
      } else {
        localStorage.setItem('selectValue', data.routeName);
      }
      
      if (['bameiNewHomePage'].includes(data.routeName)) {
        this.$router.push({
          name: data.routeName
        });
      } else if (['bameiNewSecretGarden'].includes(data.routeName)) {
        localStorage.setItem('news_title', '秘境桃源')
      } else if (['bameiNewOnlineBook'].includes(data.routeName)) {
        localStorage.setItem('news_title', '在线预定')
      } else if (['bameiNewNewslist'].includes(data.routeName)) {
        localStorage.setItem('news_title', '桃源热点')
      } else if (['bameiNewStrategy'].includes(data.routeName)) {
        localStorage.setItem('news_title', '游园攻略')
      } else if (['bameiNewServiceCenter'].includes(data.routeName)) {
        localStorage.setItem('news_title', '服务中心')
      } else {
        const { path, query, label } = data
        localStorage.setItem('news_title', label)
        this.$router.push({
          path,
          query,
        })
      }
    },
    onLanChane(type){
      if(type === 'chinese'){
        this.isEnglish = false;
      }
      if(type === 'English'){
        this.isEnglish = true;
      }
      this.Selectlanguage = type;
    }
  }
}
</script>

<style scoped>
.bameiNewHome {
  width: 100%;
  overflow: hidden;
  background: #fff;
  padding-top: 108px;
}
</style>


// WEBPACK FOOTER //
// src/pages/bameiNew/index.vue